import AccountNewIO from './components/AccountNewIO.js';
import connect from './connect';
import './assets/AccountNewIO.css';

export default connect(AccountNewIO);



// WEBPACK FOOTER //
// ./src/routes/AccountNewIO/index.js